"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var lodash_1 = __importDefault(require("lodash"));
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'isMobileView', 'compLayout'], function (_a) {
    var _b, _c;
    var compData = _a.compData, compProps = _a.compProps, isMobileView = _a.isMobileView, compLayout = _a.compLayout;
    return {
        src: getVideoUrl(compData) || '',
        loop: compProps.loop,
        controls: compProps.controlsVisibility === 'hover',
        showTitle: compProps.showVideoTitle,
        playableConfig: {
            title: compData.videoTitle || '',
            description: compData.description || '',
            poster: (_b = compData.videoRef) === null || _b === void 0 ? void 0 : _b.posterImageRef,
        },
        muted: compProps.autoplay,
        autoplay: compProps.autoplay,
        isMobileView: isMobileView,
        containerDimensions: {
            width: compLayout.width + "px",
            height: compLayout.height + "px",
        },
        currentTime: 0,
        duration: ((_c = compData.videoRef) === null || _c === void 0 ? void 0 : _c.duration) || 0,
        isPlaying: false,
        volume: compProps.autoplay ? 0 : 100,
        isMuted: compProps.autoplay,
    };
});
var getVideoUrl = function (compData) {
    var videoUrl = compData.videoUrl;
    if (videoUrl) {
        return videoUrl;
    }
    var qualities = lodash_1.default.get(compData, 'videoRef.qualities');
    if (!qualities || !qualities.length) {
        return;
    }
    var url = lodash_1.default.maxBy(qualities, 'width').url;
    return "https://video.wixstatic.com/" + url; // TODO staticVideoUrl
};
//# sourceMappingURL=VideoPlayer.js.map